<template>
  <div id="wrap">
    <div id="header">
      <div id="stanfordLogo"></div>
<!--      <GoogleLogin :callback="callback" prompt />-->
      <div id="login">
        <login></login>
      </div>
    </div>
    <div id="content">
      <div id="sidebar">
        <div id="corkboard">
          <button id="about" @click="showAbout=true" :style="{'font-size': aboutTextSize}">{{$store.getters['getUIText']('aboutseptris')}}</button>
          <button id="tips" @click="showTips = true">{{$store.getters['getUIText']('tipshints')}}</button>
        </div>
        <div id="continue">
          <button @click="continueGame" class="returning-player-button" :disabled="!savedGame">{{$store.getters['getUIText']('continuegame')}}</button>
          <button @click="startNewGame" v-if="!showResistanceCheckbox" class="returning-player-button">{{$store.getters['getUIText']('startnewgame')}}</button>
          <button @click="regionDisambiguate=true" v-if="showResistanceCheckbox" class="returning-player-button">{{$store.getters['getUIText']('startnewgame')}}</button>
<!--          <button id="resistanceCheck" v-if="showResistanceCheckbox" @click="resistanceRegion = !resistanceRegion"><input type="checkbox" v-model="resistanceRegion"><div>{{$store.getters['getUIText']('highantibioticresis')}}</div></button>-->
          <button id="tutorial" class="returning-player-button" @click="startTutorial">Tutorial</button>
        </div>
      </div>
      <div id="door" :class="{open: transitioning}"></div>
      <div id="coat"></div>
    </div>
  </div>
  <div id="modalWrap" v-if="regionDisambiguate" @click.self="regionDisambiguate = false">
    <div id="modalContent">
      <div class="close" @click="regionDisambiguate=false">&times;</div>
      <h2>Choose your region</h2>
      <button class="returning-player-button" @click="startHighResistanceGame">{{$store.getters['getUIText']('highantibioticresis')}}</button>
      <button class="returning-player-button" @click="startLowResistanceGame">{{$store.getters['getUIText']('lowantibioticresist')}}</button>
    </div>
  </div>
  <about @hide="showAbout=false" v-if="showAbout"></about>
  <tipshints @hide="showTips=false" v-if="showTips"></tipshints>
</template>

<script>
import {decodeCredential} from 'vue3-google-login';
import Login from "./login";
import About from "./about";
import API from "../assets/js/api";
import GameManager from "../assets/js/GameManager";
import Tipshints from "./tipshints";

export default {
  name: "StartScreen",
  components: {Tipshints, Login, About},
  emits: ['showGame', 'showLeaderboard'],
  data(){ return {
    transitioning: false,
    loadingLanguage: true,
    showAbout: false,
    showTips: false,
    regionDisambiguate: false,
    sessionLoaded: false
  }},
  computed: {
    savedGame(){
      console.log(this.$store.getters["user/session_id"])
      return !!this.$store.getters['user/session_id'] && this.sessionLoaded;
    },
    aboutTextSize(){
      const showInRegions = ["Français", "Test App", "Testing"]
      if(showInRegions.indexOf(process.env.VUE_APP_REGION) > -1){
        return "1.1rem"
      }
      return "auto";
    },
    resistanceRegion: {
      get(){ return GameManager.resistanceRegion === "High Antibiotic Resistance"},
      set(val){GameManager.resistanceRegion = val ? "High Antibiotic Resistance" : "Low Antibiotic Resistance" }
    },
    showResistanceCheckbox(){
      const showInRegions = ["English International", "Français", "Test App", "Testing"]
      return showInRegions.indexOf(process.env.VUE_APP_REGION) > -1;
    }
  },
  methods: {
    startHighResistanceGame(){
      this.resistanceRegion = true;
      this.startNewGame();
    },
    startLowResistanceGame(){
      this.resistanceRegion = false;
      this.startNewGame();
    },
    startNewGame(){
      // Transition after door animation over or data loaded, whichever is longest
      console.log(this.$store.getters["user/user_id"]);
      GameManager.tutorial = false;
      this.axios.all(
          [this.openDoor(),
            this.$store.dispatch("initialize", GameManager.resistanceRegion).then(()=>{
              this.$store.commit('setAvailablePatients');
            }),
            API.startNewSession(this.$store.getters["user/user_id"])
                .then(response=>{
                  if(response){
                    this.$store.commit("user/setSessionId", response.data.session_id);
                  }
                })
          ]
      )
        .then(()=>{
          this.$emit("showGame");
          GameManager.StartGame();
        }); // This event caught by App.vue
    },
    continueGame(){
      GameManager.tutorial = false;
      const saveData = this.$store.getters.getSaveData;
      console.log(saveData);
      this.axios.all([
          this.openDoor(),
          this.$store.dispatch("initialize")
      ])
          .then(()=>{
            //this.$store.getters["getActionById"]("aspirin");
            GameManager.LoadGame(saveData.score, saveData.speed, saveData.start_time, saveData.patients);
            this.$emit("showGame");
          })
    },
    startTutorial() {
      GameManager.tutorial = true;
      this.axios.all([this.openDoor(),
        this.$store.dispatch("initTutorial").then(()=>this.$store.commit('setAvailablePatients'))
      ])
          .then(() => {
            this.$emit("showGame");
            GameManager.StartGame();
          });
    },
    openDoor(){
      // Door open animation must take at least one second.
      this.transitioning = true;
      let time = window.innerWidth > 750 ? 1000 : 0;
      return new Promise((resolve => {
        setTimeout(()=>{resolve()}, time);
      }));
    },
    callback(data){
      const decoded = decodeCredential(data.credential)
      this.$store.commit("user/setName", { firstName: decoded.given_name, lastName: decoded.family_name });
      this.$store.commit("user/setUserId", decoded.email);
      API.registerUser(this.$store.getters["user/user_id"], this.$store.getters["user/first_name"], this.$store.getters["user/last_name"]);
      // {
      //   "iss": "https://accounts.google.com",
      //     "nbf": 1658865004,
      //     "aud": "781905110527-s2rjnapqnlo6hact2j793akl6ln0alvr.apps.googleusercontent.com",
      //     "sub": "113694820421678723687",
      //     "hd": "studiocypher.com",
      //     "email": "ian@studiocypher.com",
      //     "email_verified": true,
      //     "azp": "781905110527-s2rjnapqnlo6hact2j793akl6ln0alvr.apps.googleusercontent.com",
      //     "name": "Ian Pottmeyer",
      //     "picture": "https://lh3.googleusercontent.com/a/AItbvmn4bOE4bxb2V3x_Ehqhl0RFyas3ETT8thdRtsU=s96-c",
      //     "given_name": "Ian",
      //     "family_name": "Pottmeyer",
      //     "iat": 1658865304,
      //     "exp": 1658868904,
      //     "jti": "56a7dfd7bff19366a1fe4704f579aa50ee710c36"
      // }
    },
  },
  mounted(){
    this.transitioning = false;
    this.$store.dispatch("loadUILanguage").then(()=>this.loadingLanguage = false);
    this.$store.dispatch("loadAbout");
    if(this.$store.getters["user/session_id"]){
      API.loadSession(this.$store.getters["user/session_id"]).then(response=>{
        if(response.data.user_id !== this.$store.getters["user/user_id"]){
          console.error("Requested Session is for a different user.");
          this.$store.dispatch("user/deleteUser");
        } else {
          this.$store.commit("user/setName", {firstName: response.data.first_name, lastName: response.data.last_name})
          this.$store.commit("setSaveDataDirectly", response.data.session);
        }
        this.sessionLoaded = true;
      })
    }
  }
}
</script>


<style scoped lang="less">
@import '../assets/less/colors';
@font-face {
  font-family: Kalam;
  src: url('../assets/fonts/Kalam-Bold.ttf');
};

@media screen and (max-width: 920px){
  #coat{
    display: none;
  }
}
@media screen and (max-width: 750px){
  #header{
    height: 120px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  #stanfordLogo{
    height: 50px;
    width: 300px;
    max-width: calc(100vw - 80px);
    background: url("../assets/images/Septris-sprite-start.png") -0px -3px;
    background-size: 294%;
  }
  #login{
    //position: absolute;
    //right: 40px;
    //top: 5px;
  }
  #door{
    display: none;
  }
  #sidebar{
    margin: 0;
  }
  #content{
    align-items: center;
  }
}
@media screen and (min-width: 751px){
  #header{
    height: 60px;
  }
  #stanfordLogo{
    height: 50px;
    width: 300px;
    max-width: calc(100vw - 80px);
    margin-left: 40px;
    background: url("../assets/images/Septris-sprite-start.png") -0px -3px;
  }
  #login{
    position: absolute;
    right: 40px;
    top: 5px;
  }
  #sidebar{
    margin: 0 0 2vh 6vh;
  }
  #content{
    align-items: end;
  }
}
#wrap{
  width: 100%;
  height: 100%;
  background: @darkgray;
}
#content{
  min-height: 430px;
  width: 100%;
  background: @lightgray;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  flex-direction: row-reverse;
}
#header{
  //height: 60px;
  background-image: linear-gradient(to top, #5c0d1d 0%, #b01937 10px, @lightgray 10px, @lightgray 100%);
}
#coat{
  height: 220px;
  width: 120px;
  margin: 0 6vh 6vh 0;
  background: url("../assets/images/Septris-sprite-start.png") -649px -187px;
}
#door{
  height: calc(40vw * 0.873);
  width: 40vw;
  max-height: 381px;
  max-width: 436px;
  background: url("../assets/images/Septris-sprite-doors-closed.png") no-repeat bottom;
  background-size: contain;
  &.open{
    background-image: url("../assets/images/Septris-sprite-doors-open.png");
  }
}
#sidebar{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
#corkboard{
  position: relative;

  height: 138px;
  width: 256px;
  margin: 1.5em 0;
  background: url("../assets/images/Septris-sprite-start.png") -24px -87px;
  button{
    font-family: Kalam, sans-serif;
    font-size: 1.4rem;
    text-align: center;
    line-height: 1.3;color: @red;
    text-decoration: none;
    cursor: pointer;
    border: 0;
    &:hover{
      color: @black;
    }
  }
}
#about{
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 18px;
  left: 12px;
  height: 70px;
  width: 95px;
  background-image: linear-gradient(to right bottom, @white, #f2e8c0);
  box-shadow: 3px 3px 6px rgba(0,0,0,0.2);
  transform: rotate(-5deg);
}
#tips{
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 30px;
  right: 28px;
  height: 70px;
  width: 95px;
  background-image: linear-gradient(to right bottom, @white, #f2e8c0);
  box-shadow: 3px 3px 6px rgba(0,0,0,0.2);
  transform: rotate(7deg);
}
#startbutton{
  height: 185px;
  width: 185px;
  box-sizing: border-box;
  padding: 35px 37px 30px 25px;
  background: url("../assets/images/Septris-sprite-start.png") -30px -250px;
  color: @white;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 2rem;
  line-height: 1.3;
  font-family: Kalam, sans-serif;
  &:hover{
    background-position-x: -220px;
    cursor: pointer;
    text-shadow: 0 0 10px @white;
  }
}

.returning-player-button{
  display: block;
  width: 185px;
  box-sizing: border-box;
  margin: 0.5rem 0 1rem;
  color: white;
  font-size: 1.25rem;
  font-family: Kalam, sans-serif;
  padding: 0.75rem;
  border-radius: .75rem;
  border: 0.15em solid darken(@lightgray, 10%);
  box-shadow: 0.15em 0.15em 0.15em rgba(0,0,0,0.25);
  background-image: linear-gradient(160deg, lighten(@red, 20%), darken(@red, 5%));
  cursor: pointer;
  &:hover{
    background-image: linear-gradient(160deg, lighten(@red, 30%), lighten(@red, 5%));
  }
  &:disabled, &:disabled:hover{
    cursor: default;
    background-image: linear-gradient(160deg, desaturate(lighten(@red, 20%), 100%), desaturate(darken(@red, 5%), 100%));
  }
}
#resistanceCheck{
  display: flex;
  width: 182px;
  box-sizing: border-box;
  padding: 0.25rem;
  justify-content: flex-start;
  align-items: center;
  text-align: left;
  border-radius: .75rem;
  border: 1px solid @darkgray;
  cursor: pointer;
  input{
    display: block;
    height: 1.5rem;
    width: 1.5rem;
    margin-right: 0.75rem;
  }
}

#modalWrap{
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  background: rgba(0,0,0,0.3);
  #modalContent{
    position: relative;
    background: @white;
    padding: 1em;
    width: 30em;
    max-width: 80%;
    text-align: center;
    .close{
      position: absolute;
      top: 0.5em;
      right: 0.5em;
      font-size: 1.5em;
      font-weight: bold;
      cursor: pointer;
    }
    button{
      width: 20em;
      max-width: 90%;
      margin: 1em auto;
    }
  }
}
</style>
